import ApplicationAdapter from './application';

export default class Person extends ApplicationAdapter {
  namespace = 'people/v4';
}
